import React from "react";

export function MaskedText({ as: Tag = "span", className = "", children, ...props }) {
  return (
    <Tag className={`mask-reveal ${className}`.trim()} {...props}>
      <span className="mask-reveal__inner">{children}</span>
    </Tag>
  );
}
export function SectionLabel({ number, children }) {
  return (
    <div className="section-label" data-reveal="fade">
      <span className="section-label__mark" aria-hidden="true">
        <i /><i /><i /><i />
      </span>
      <span>{number}</span>
      <span>{children}</span>
    </div>
  );
}
